import Marionette from 'backbone.marionette';
import Navigator from 'app';
import membersItemviewTmpl from '../templates/members_itemview.tpl';
export default Marionette.ItemView.extend({
  template: membersItemviewTmpl,
  events: {
    "click div.js-show-member-detail": "showMemberDetail"
  },
  showMemberDetail: function showMemberDetail(e) {
    e.preventDefault();
    e.stopPropagation();
    Navigator.vent.trigger("member:detail:show", this.model.id);
  }
});